import styled from "styled-components";

const TimelineContainer = styled.div`
    .timeline__row {
    margin: auto 42px;
    height: 110px;
    padding-top: 36px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .time-line__block {
    display: flex !important;
    justify-content: space-around !important;

    .time-line__step {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      top: 18px;

      &--inactive {
        .circleIconState {
          fill: #bcbcbc;
        }
      }
    }

    [class^="time-line__step-state"] {
      width: 100px;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
    }

    .time-line__step-state {
      &--in-transit {
        color: #7e73f8;
      }
      &--in-construction {
        color: #c7b301;
      }
      &--discharging {
        color: #616161;
      }
    }

    .time-line__step-time {
      font-size: 12px;
      margin-top: 4px;
      text-align: center;
    }

    .RSPBprogressBar {
      border-radius: 0;
      width: calc(100% - 40px);

      .RSPBstep {
        .inactive .circleIconState {
          fill: #bcbcbc;
        }
        .icon {
          border-radius: 50%;
          padding: 5px;
          svg {
            width: 35px;
          }
        }
      }
      .RSPBprogression {
        border-radius: 0;
      }
    }

    &.construction {
      .RSPBprogressBar {
        .RSPBprogression {
          background: linear-gradient(
            to right,
            rgb(126, 115, 248) 0%,
            rgb(126, 115, 248) 100%
          );
        }
      }
    }

    &.discharge {
      .RSPBprogression {
        background: linear-gradient(
          to right,
          rgb(126, 115, 248) 0%,
          rgb(126, 115, 248) 50%,
          rgb(199, 179, 1) 50%,
          rgb(199, 179, 1) 100%
        );
      }
    }
  }

  .communication {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #666666;

    svg {
      height: 20px;
      fill: #64dd17;
      margin-right: 4px;
    }
  }
`;

export default { TimelineContainer };